<template>
  <div>
    <!-- 일반 헤더 -->
    <div v-if="!isPooqzone" class="header">
      <!-- IE 지원종료 후 제거 -->
      <section class="notice-area" v-if="showIeNotice">
        <div class="wrap">
          <p tabindex="0">이 브라우저는 더 이상 지원하지 않습니다. Chrome, Microsoft Edge 등으로 wavve를 이용해 주세요.</p>
          <span tabindex="0">Flash Player 지원 종료로 인해, 2021년 1월 12일부터 현재 브라우저에 대한 지원이 종료됩니다.</span>
          <ul class="browser-link-list">
            <li>
              <a href="https://www.google.co.kr/chrome/browser/desktop/index.html" target="_blank">
                <span>Chrome 다운로드</span>
              </a>
            </li>
            <li>
              <a href="https://www.microsoft.com/ko-kr/edge" target="_blank">
                <span>Microsoft Edge 다운로드</span>
              </a>
            </li>
          </ul>
        </div>
      </section>
<!--    <div v-if="!isPooqzone" :class="borderBottomClass">-->
      <util-menu/>
      <gnb :key="$route.fullPath"/>
    </div>

    <!-- 웨이브온 헤더 -->
    <div v-else class="header hd-pooqzone">
      <section class="notice-area" v-if="showIeNotice">
        <div class="wrap">
          <p tabindex="0">이 브라우저는 더 이상 지원하지 않습니다. Chrome, Microsoft Edge 등으로 wavve를 이용해 주세요.</p>
          <span tabindex="0">Flash Player 지원 종료로 인해, 2021년 1월 12일부터 현재 브라우저에 대한 지원이 종료됩니다.</span>
          <ul class="browser-link-list">
            <li>
              <a href="https://www.google.co.kr/chrome/browser/desktop/index.html" target="_blank">
                <span>Chrome 다운로드</span>
              </a>
            </li>
            <li>
              <a href="https://www.microsoft.com/ko-kr/edge" target="_blank">
                <span>Microsoft Edge 다운로드</span>
              </a>
            </li>
          </ul>
        </div>
      </section>
      <pooq-zone-util-menu :agencyname="agencyname"/>
      <pooq-zone-gnb :isPlayycomic="isPlayycomic" :isplayymovie="isplayymovie" :key="$route.fullPath"/>
    </div>
    <slot/>
<!--    <div class="btn-float-box">-->
<!--      <btn-kakao v-if="showKaKaoBizBtn"/>-->
<!--      <btn-top/>-->
<!--    </div>-->
  </div>
</template>

<script>
import Gnb from './header/Gnb'
import UtilMenu from './header/UtilMenu'
import PooqZoneGnb from './header/PooqZoneGnb'
import PooqZoneUtilMenu from './header/PooqZoneUtilMenu'
import _ from 'lodash'
import { autoLoginProc } from '@/common/utils/login'
import cookie from '@/common/utils/cookie'
import { getServiceLocation } from '@/common/utils/request'
import { getServiceLocationInfo, setServiceLocationInfo } from '@/common/utils/common'

export default {
  components: {
    Gnb,
    UtilMenu,
    PooqZoneGnb,
    PooqZoneUtilMenu
  },
  data () {
    return {
      isPooqzone: cookie.isWavveOn(),
      pooqzoneInfo: cookie.getPooqZoneInfo(),
      agencyname: '',
      isPlayycomic: 'n',
      isplayymovie: 'y',
      selectedIndex: 0,
      showIeNotice: window.uaInfo.getBrowser().name === 'IE'
    }
  },
  methods: {},
  computed: {
    // borderBottomClass () {
  //     const routeName = this.$route.name
  //     const routeFullPath = this.$route.fullPath
  //     let BottomBorder = 'header bottom-border'
  //     if (routeName === 'home' || routeName === 'schedule' || routeFullPath.indexOf('mypooq/') > 0 || routeFullPath.indexOf('voucher/') > 0 ||
  //       routeFullPath.indexOf('event/') > 0 || routeFullPath.indexOf('customer/') > 0 || routeFullPath.indexOf('search/') > 0) {
  //       BottomBorder = 'header'
  //     }
  //     return BottomBorder
  //   },
    showKaKaoBizBtn () {
      const pathName = window.location.pathname
      return (pathName === '/customer/faq.html' || pathName === '/customer/notice_list.html')
    }
  },
  created () {
    if (this.pooqzoneInfo && this.pooqzoneInfo.isPooqzone) {
      // 업체명
      this.agencyname = this.pooqzoneInfo.agencyname
      this.isPlayycomic = this.pooqzoneInfo.isPlayycomic
      this.isplayymovie = this.pooqzoneInfo.isplayymovie
    }

    // 자동 로그인 처리
    const autoLogin = autoLoginProc()
    const isThenable = _.get(autoLogin, 'then', false)
    if (isThenable) {
      autoLogin.then(() => {
        window.location.reload()
      })
    } else {
      const credential = cookie.getCredential()
      if (credential !== 'none') {
        if (getServiceLocationInfo() === null) {
          getServiceLocation(credential).then(({ data }) => {
            setServiceLocationInfo(data)
            window.location.reload()
          })
        }
      }
    }
  }
}
</script>
<!--<style scoped>-->
<!--.header.bottom-border{-->
<!--  /*border-bottom:1px solid #2f2f2f;*/-->
<!--}-->
<!--</style>-->
